import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ThesisSection } from '../components/ThesisSection';
import { ProductEngineSection } from '../components/ProductEngineSection';
import { TeamSection } from '../components/TeamSection';
import { ContactSection } from '../components/ContactSection';
import { FooterSection } from '../components/FooterSection';

export default function LandingPage() {
  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <Header />
      <HeroSection />
      <ThesisSection />
      <ProductEngineSection />
      <TeamSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
